import * as React from 'react';
import ReactHTMLParser from 'react-html-parser';
import { Link } from '@latitude/link';
import { Accordion } from '@latitude/accordion';
import { Box } from '@latitude/box';
import { BUTTON_STYLE, FONT_WEIGHT, MARGIN } from '@latitude/core/utils/constants';
import { Text } from '@latitude/text';
import { Outer, Inner, Mobile, Desktop, SiteLinksGroup, CardContainer, List, ListItem } from './SiteLinks.styles';
const SiteLinks = props => /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(Inner, null, /*#__PURE__*/React.createElement(Mobile, null, /*#__PURE__*/React.createElement(Accordion, {
  titleBgColor: "white",
  contentBgColor: "white",
  fgColor: "black",
  minimumMargin: true,
  items: props.data.map((item, i) => ({
    id: `footer-acc-${i}`,
    title: item.header,
    content: /*#__PURE__*/React.createElement(SiteLinksList, {
      data: item.menuItems
    })
  }))
})), /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(SiteLinksGroup, {
  cardData: props.cardData
}, props.data.map((item, i) => /*#__PURE__*/React.createElement(SiteLinksList, {
  key: i,
  title: item.header,
  className: "site-links--desktop",
  data: item.menuItems
})), props.cardData && /*#__PURE__*/React.createElement(CardContainer, null, /*#__PURE__*/React.createElement("img", {
  src: props.cardData.img,
  alt: "card"
}), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Link, {
  button: BUTTON_STYLE.PRIMARY,
  href: props.cardData.href,
  trackId: "footer-apply-now"
}, props.cardData.text)))))));
const SiteLinksList = props => /*#__PURE__*/React.createElement(List, null, props.title && /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Text, {
  fontWeight: FONT_WEIGHT.BOLD,
  margin: `0 0 ${MARGIN.M16}`,
  fontSize: "1.1rem"
}, ReactHTMLParser(props.title))), props.data.map((item, i) => /*#__PURE__*/React.createElement(ListItem, {
  key: i
}, /*#__PURE__*/React.createElement(Link, {
  href: item.link
}, item.label))));
export default SiteLinks;